import { render, staticRenderFns } from "@/components/Layout/Clientes/Administracion_clientes/Editar_clientes/Editar_clientes.html?vue&type=template&id=0fe097a5&scoped=true&"
import script from "@/components/Layout/Clientes/Administracion_clientes/Editar_clientes/Editar_clientes.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Clientes/Administracion_clientes/Editar_clientes/Editar_clientes.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Clientes/Administracion_clientes/Editar_clientes/Editar_clientes.css?vue&type=style&index=0&id=0fe097a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe097a5",
  null
  
)

export default component.exports